import { getClassLevel } from "../shared/getClassLevel";
import { evaluateHex } from "./hex";

// Hex is only on the Warlock spell list, so its hit damage is owned by this adapter.
const warlockAdapter = Object.freeze({
  id: "warlock",
  getClassLevel: (character) => getClassLevel(character, "warlock"),
  evaluateOnHit: (context, queries) => evaluateHex({ context, queries }),
});

export default warlockAdapter;
